import MonthlySummary from '../MonthlySummary';
class AnnualSummary extends MonthlySummary {
    numberOfYears;
    constructor(data) {
        super(data);
        this.numberOfYears = data.numberOfYears;
    }
}
export default AnnualSummary;
